<template>
  <div ref="carousel" :id="carouselId" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button"
              :data-bs-target="carouselElementId"
              v-for="(img, index) in images"
              :key="index"
              :data-bs-slide-to="index"
              :class="{'active': index === 0}"
              :aria-current="index === 0"
              :aria-label="'Slide ' + index"
      >
      </button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item bg-black" v-for="(img, index) in images" :key="index" :class="{'active': index === 0}">
        <img ref="zoomImg" class="d-block" :src="active ? `${imgur}/${img}.jpg` : ''" alt="">
      </div>
    </div>
    <button class="carousel-control-prev" type="button" :data-bs-target="carouselElementId" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" :data-bs-target="carouselElementId" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>

<script>
import {url} from "@/constants";
import {Carousel} from "bootstrap";
import Zoom from "smooth-zoom";

export default {
  name: "Carousel",
  props: {
    id: {type: String, required: true},
    images: {type: Array, required: true},
    active: {type: Boolean, required: true}
  },
  data() {
    return {
      carouselId: 'carousel-' + this.id,
      carouselElementId: '#' + 'carousel-' + this.id,
      imgur: url.IMGUR
    }
  },
  mounted() {
    new Carousel(this.$refs.carousel, {
      interval: false,
      touch: true
    });

    Zoom(this.$refs.zoomImg, {
      background: 'rgba(0, 0, 0, .99)',
    });
  }
}
</script>

<style scoped>
  .carousel-item {
    background-image: url("../assets/tail-spin.svg");
    background-repeat: no-repeat;
    background-position: center center;
  }

  .carousel > button {
    background: #1c1c1c;
  }

  img {
    cursor: zoom-in;
    margin: auto;
    max-height: 150px;
    height: 150px;
    min-height: 150px;
  }
</style>
